import { useTranslation } from 'react-i18next';
import { FilterReportType } from '@cbo/shared-library';
import Multiselect from '../../../components/GlobalFilterBar/Multiselect/Multiselect';
import { useFiltersQuery } from '../../../../api/sales/queries';
import { DatasetColumn } from '../../CentralReports/components/CreateReportDialog';

interface FilterProps {
  filter: DatasetColumn;
}

/**
 * Component to render a filter and its options based on the provided DatasetColumn.
 * @param filter The DatasetColumn object containing filter details.
 * @returns A JSX element representing the filter component.
 */
function Filter({ filter }: FilterProps) {
  const { t } = useTranslation('translation', { keyPrefix: 'admin.customReports.filterFields' });
  const { data, loading } = useFiltersQuery(filter.filterType as FilterReportType);

  if (!filter.filterType) return null; // filter not eligible

  return (
    <Multiselect
      controllerName={`filter_${filter.id}`}
      options={data?.results ?? []}
      singular={t(`${filter.filterType}`)}
      plural={t(`plurals.${filter.filterType}`)}
      titleText={t(`plurals.${filter.filterType}`)}
      onlyFilterContainer={false}
      defaultChecked={false}
      loading={loading}
    />
  );
}

export default Filter;
